module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 66
// module chunks = 0 1 2 3